
import * as ipxRuntime$2exZgFU58v from '/app/template1/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "ddexperiences-s3.fra1.digitaloceanspaces.com",
    "turpal-connect-media.fra1.digitaloceanspaces.com",
    "turpal-web.fra1.cdn.digitaloceanspaces.com",
    "ur2h9smi.turpal.com",
    "tw028jd0.turpal.com",
    "d1i3enf1i5tb1f.cloudfront.net",
    "image.kkday.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$2exZgFU58v, defaults: {"modifiers":{"format":"webp"}} }
}
        